import { SLIDESHOW_TYPE, SLIDESHOW_VIDEO_FORMAT } from '../Constants/constants';
import { restaurantSlideshowValidationConstants } from '../Constants/validationConstants';

class RestaurantSlideshowValidation {

  version;
  errorMap;
  restaurantSlideshowErrorMap;
  valid;

  constructor() {

    if (!RestaurantSlideshowValidation.instance) {
      this.version = 0;
      this.valid = true;
      this.errorMap = new Map();
      this.restaurantSlideshowErrorMap = new Map();
      RestaurantSlideshowValidation.instance = this;
    }
    return RestaurantSlideshowValidation.instance;
  }

  validateEditRestaurantSlideshow(restaurantSlideshow) {
    this.resetErrorMessages();
    this.handleValidateEditRestaurantSlideshow(restaurantSlideshow);
    this.version++;
  }

  validateCreateRestaurantSlideshow(restaurantSlideshow) {
    this.resetErrorMessages();
    this.handleValidateCreateRestaurantSlideshow(restaurantSlideshow);
    this.version++;
  }

  resetErrorMessages() {
    this.errorMap = new Map();
    this.restaurantSlideshowErrorMap = new Map();
    this.valid = true;
  }

  getVersion() {
    return this.version;
  }

  isValid() {
    return this.valid;
  }

  getErrorMessages(key, uniqueCode) {
      return this.restaurantSlideshowErrorMap.get(key) ;
  }

  handleValidateEditRestaurantSlideshow(restaurantSlideshow) {

    if(!restaurantSlideshow.media){
      this.setRestaurantSlideshowErrorMapMessages(restaurantSlideshowValidationConstants.KEY_COS_FILE_URL, "Missing Media");
    }

    if(restaurantSlideshow.media && !restaurantSlideshow.media.cosFileUrl){
      this.setRestaurantSlideshowErrorMapMessages(restaurantSlideshowValidationConstants.KEY_COS_FILE_URL, "Missing Media");
    }

    if(restaurantSlideshow.media && restaurantSlideshow.type === SLIDESHOW_TYPE.VIDEO ){

      if(restaurantSlideshow.media.mime && !is264H(restaurantSlideshow.media.mime)) {
        this.setRestaurantSlideshowErrorMapMessages(restaurantSlideshowValidationConstants.KEY_COS_FILE_URL, "H264 Format is required");
      }

      if(restaurantSlideshow.media.duration < 10) {
        this.setRestaurantSlideshowErrorMapMessages(restaurantSlideshowValidationConstants.KEY_COS_FILE_URL, "At least 10s is required");
      }

    }

    //date
    const slideshowStartTimestamp = Number(restaurantSlideshow.startDisplayTimestamp);
    const slideshowEndTimestamp = Number(restaurantSlideshow.endDisplayTimestamp);

    if(!isNaN(slideshowStartTimestamp) && !isNaN(slideshowEndTimestamp) 
    && slideshowStartTimestamp!==0
    && slideshowEndTimestamp!==0
    && slideshowStartTimestamp> slideshowEndTimestamp) {
      this.setRestaurantSlideshowErrorMapMessages(restaurantSlideshowValidationConstants.KEY_END_DISPLAY_TIMESTAMP, "Slideshow start timestamp is larger than slideshow end timestamp");
    }

    if (!restaurantSlideshow.type) {
      this.setRestaurantSlideshowErrorMapMessages(restaurantSlideshowValidationConstants.KEY_TYPE, "Missing Type");
    }
    if (!restaurantSlideshow.sequence && restaurantSlideshow.sequence !== 0) {
      this.setRestaurantSlideshowErrorMapMessages(restaurantSlideshowValidationConstants.KEY_SEQUENCE, "Missing Display Sequence");
    }
    if (!restaurantSlideshow.status) {
      this.setRestaurantSlideshowErrorMapMessages(restaurantSlideshowValidationConstants.KEY_STATUS, "Missing Status");
    }
  }

  handleValidateCreateRestaurantSlideshow(restaurantSlideshowList) {
    
    for(const slideshow of restaurantSlideshowList){

      const id = slideshow.customId;

      if(!slideshow.media){
        this.setRestaurantSlideshowErrorMapMessages(`${id}-${restaurantSlideshowValidationConstants.KEY_COS_FILE_URL}`, "Missing Media");
      }
  
      if(slideshow.media && !slideshow.media.cosFileUrl){
        this.setRestaurantSlideshowErrorMapMessages(`${id}-${restaurantSlideshowValidationConstants.KEY_COS_FILE_URL}`, "Missing Media");
      }

      if(slideshow.media && slideshow.type === SLIDESHOW_TYPE.VIDEO ){

        if(slideshow.media.mime && !is264H(slideshow.media.mime)) {
          this.setRestaurantSlideshowErrorMapMessages(`${id}-${restaurantSlideshowValidationConstants.KEY_COS_FILE_URL}`, "H264 Format is required");
        }
  
        if(slideshow.media.duration < 10) {
          this.setRestaurantSlideshowErrorMapMessages(`${id}-${restaurantSlideshowValidationConstants.KEY_COS_FILE_URL}`, "At least 10s is required");
        }
  
      }
  
      //date
      const slideshowStartTimestamp = Number(slideshow.startDisplayTimestamp);
      const slideshowEndTimestamp = Number(slideshow.endDisplayTimestamp);

      if(!isNaN(slideshowStartTimestamp) && !isNaN(slideshowEndTimestamp) 
      && slideshowStartTimestamp!==0
      && slideshowEndTimestamp!==0
      && slideshowStartTimestamp> slideshowEndTimestamp) {
        this.setRestaurantSlideshowErrorMapMessages(`${id}-${restaurantSlideshowValidationConstants.KEY_END_DISPLAY_TIMESTAMP}`, "Slideshow start timestamp is larger than slideshow end timestamp");
      }
  
      if (!slideshow.type) {
        this.setRestaurantSlideshowErrorMapMessages(`${id}-${restaurantSlideshowValidationConstants.KEY_TYPE}`, "Missing Type");
      }
      if (!slideshow.sequence && slideshow.sequence !== 0) {
        this.setRestaurantSlideshowErrorMapMessages(`${id}-${restaurantSlideshowValidationConstants.KEY_SEQUENCE}`, "Missing Display Sequence");
      }
      if (!slideshow.status) {
        this.setRestaurantSlideshowErrorMapMessages(`${id}-${restaurantSlideshowValidationConstants.KEY_STATUS}`, "Missing Status");
      }

      if(!this.valid) {
        this.setRestaurantSlideshowErrorMapMessages(`${id}`, "Has Error(s)");
      }

    }

  }


  setRestaurantSlideshowErrorMapMessages(key, errorMessages, valid = false) {
    this.restaurantSlideshowErrorMap.set(key, errorMessages);
    // console.log("restaurantMediaErrorMap", this.restaurantMediaErrorMap)
    if (!valid) {
      this.valid = false;
    }
  }

}

const validation = new RestaurantSlideshowValidation();
export default validation;

const is264H = (mime) => {

  mime = mime.replace(/\s/g,'');
  const parts = mime.split(';');
  if(parts.length<2) {
    return false;
  }
  const codecs = parts[1];
  const prefix = 'codecs="';
  if(codecs.startsWith(`${prefix}${SLIDESHOW_VIDEO_FORMAT.H264_BASELINE}`) 
      || codecs.startsWith(`${prefix}${SLIDESHOW_VIDEO_FORMAT.H264_BASELINE_LOWERCASE}`) 
      || codecs.startsWith(`${prefix}${SLIDESHOW_VIDEO_FORMAT.H264_MAIN}`) 
      || codecs.startsWith(`${prefix}${SLIDESHOW_VIDEO_FORMAT.H264_MAIN_LOWERCASE}`) 
      || codecs.startsWith(`${prefix}${SLIDESHOW_VIDEO_FORMAT.H264_HIGH}`) 
      || codecs.startsWith(`${prefix}${SLIDESHOW_VIDEO_FORMAT.AVC1}`) 
    ) {
      return true;
    }
  return false;
}